import { useRef } from "react";
import { useIsomorphicLayoutEffect } from "./use-isomorphic-layout-effect";
export function useScheduleUpdate(deps) {
    if (deps === void 0) { deps = []; }
    var scheduleUpdateRef = useRef(null);
    useIsomorphicLayoutEffect(function () { return function () {
        if (scheduleUpdateRef.current) {
            scheduleUpdateRef.current();
        }
    }; }, deps);
    return scheduleUpdateRef;
}
//# sourceMappingURL=use-schedule-update.js.map